<template>
  <div>
    <slot><a :href="link" v-analytics="{label:'header_logo'}" class="global-navi-default-logo">@cosme</a></slot>
  </div>
</template>

<script>
import Config    from '../../../libs/config';
import analytics from '../../../directives/analytics';

export default {
  name      : 'service-logo',
  directives: {
    analytics,
  },
  data: function() {
    return {
      link: Config.SERVICE_LINK.ATCOSME.TOP.URL,
    };
  },
};
</script>
